import { render } from "./DanhSachTuyenKhiBanDoLoi.vue?vue&type=template&id=3ec8d344&scoped=true"
import script from "./DanhSachTuyenKhiBanDoLoi.vue?vue&type=script&lang=js"
export * from "./DanhSachTuyenKhiBanDoLoi.vue?vue&type=script&lang=js"

import "./DanhSachTuyenKhiBanDoLoi.vue?vue&type=style&index=0&id=3ec8d344&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec8d344"]])

export default __exports__